/*
 * Maison Astier · ajout panier en un clic (pack + upsell drawer).
 * Réutilise la mécanique native Dawn: POST /cart/add.js avec `sections`,
 * puis cart.renderContents(response) (rafraichit + ouvre le tiroir panier).
 * Élément déclencheur: tout [data-ma-add] dont la valeur est un tableau JSON d'ids de variantes.
 */
(function () {
  function addToCart(btn, ids) {
    if (!ids || !ids.length) return;
    if (btn.getAttribute('aria-disabled') === 'true') return;
    btn.setAttribute('aria-disabled', 'true');
    btn.classList.add('loading');

    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var sections = cart && cart.getSectionsToRender ? cart.getSectionsToRender().map(function (s) { return s.id; }) : [];
    var addUrl = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add';
    var cartUrl = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';

    fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: ids.map(function (id) { return { id: id, quantity: 1 }; }),
        sections: sections,
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.status) {
          // erreur Shopify (rupture, variante invalide)
          return;
        }
        if (cart && cart.renderContents) {
          cart.renderContents(res);
        } else {
          window.location = cartUrl;
        }
      })
      .catch(function (e) { console.error('ma-upsell', e); })
      .finally(function () {
        btn.classList.remove('loading');
        btn.removeAttribute('aria-disabled');
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ma-add]');
    if (!btn) return;
    e.preventDefault();
    var ids;
    try { ids = JSON.parse(btn.getAttribute('data-ma-add')); } catch (_) { return; }
    addToCart(btn, ids);
  });
})();
